import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { ScrollFreezeServiceTypes } from '@frontend/sports/common/core/feature/scroll-freeze';
import { ModalDialogOptions, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';
import { TrackingType, trackingConstants } from '@frontend/sports/tracking/feature';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';

import { EditBetOnBoardingComponent } from '../components/onboarding/edit-bet-onboarding.component';

@Injectable()
export class EditBetOnBoardingService {
    private modalDialogRef: ModalRef | undefined = undefined;
    private readonly _doc = inject(DOCUMENT);

    constructor(
        private modalDialogService: ModalDialogService,
        private epcotConfigService: EpcotConfigService,
    ) {}

    openDialog(): void {
        this.closeDialog();

        const modalDialogContainer = this._doc.querySelector<HTMLElement>('.column-right .widget-slot') || void 0;
        const epcotClass = this.epcotConfigService.isEnabled() ? 'epcot-enabled' : '';

        const modalSettings: ModalDialogOptions<void> = {
            settings: {
                fit: !!modalDialogContainer,
                isModalDialog: false,
                cssClass: `editbet-onboarding-dialog betslip-vars-scope ${epcotClass}`,
                tracking: {
                    name: trackingConstants.EVENT_EDIT_BET,
                    data: {
                        [trackingConstants.PAGE_REFERRING_ACTION]: 'Sports_EditBet_Info_Screen_Loaded',
                        [trackingConstants.PAGE_SITE_SECTION]: 'myBets',
                    },
                    type: TrackingType.PageName,
                },
                inColumn: !!modalDialogContainer,
                container: modalDialogContainer,
                scrollFreezeType: modalDialogContainer ? ScrollFreezeServiceTypes.None : ScrollFreezeServiceTypes.All,
                backdropClass: 'editbet-onboarding-dialog-backdrop',
            },
        };

        this.modalDialogRef = this.modalDialogService.openDialog(EditBetOnBoardingComponent, modalSettings);
        this.modalDialogRef.result.catch(() => this.closeDialog());
    }

    closeDialog(): void {
        if (this.modalDialogRef) {
            this.modalDialogRef.dismiss();
            this.modalDialogRef = undefined;
        }
    }
}
